import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from '../../../services/loading.service';
import { TranslateService } from '@ngx-translate/core';
import { ReportingService } from 'src/app/services/reporting.service';
import { TableColumn } from 'src/app/models/table-column.model';
import { DatePipe } from '@angular/common';
import { ReportComplianceModel } from 'src/app/models/reporting/report-compliance.model';
import { CourseParticipationStatusModel } from 'src/app/models/course/course-participation-status.model';

@Component({
  selector: 'app-reporting-compliance',
  templateUrl: './reporting-compliance.component.html',
  styleUrls: ['./reporting-compliance.component.scss'],
  standalone: false
})
export class ReportingComplianceComponent {
  reportData: ReportComplianceModel[] = [];
  yearFilter: number;

  yearsDropdownDataSource: any[] = [
    {
      id: new Date().getFullYear(),
      name: new Date().getFullYear(),
    },
    {
      id: new Date().getFullYear() - 1,
      name: new Date().getFullYear() - 1,
    },
    {
      id: new Date().getFullYear() - 2,
      name: new Date().getFullYear() - 2,
    },
    {
      id: new Date().getFullYear() - 3,
      name: new Date().getFullYear() - 3,
    },
    {
      id: new Date().getFullYear() - 4,
      name: new Date().getFullYear() - 4,
    },
  ];

  reportColumns: TableColumn[] = [
    {
      caption: this.translateService.instant('COMMON.FIELDS.TRAINING'),
      dataField: 'course.name',
      dataType: 'string',
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.LAST-NAME'),
      dataField: 'lastName',
      dataType: 'string',
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.FIRST-NAME'),
      dataField: 'firstName',
      dataType: 'string',
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.EMAIL'),
      dataField: 'email',
      dataType: 'string',
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.LOCATION'),
      dataField: 'location.name',
      dataType: 'string',
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.STATUS'),
      dataField: 'status',
      cellValue: (data: ReportComplianceModel): string => {
       switch (data.status) {
          case CourseParticipationStatusModel.Completed:
            return this.translateService.instant(
              'ADMINISTRATION.PROCESSING-PROGRESS-STATUSES.CLOSED'
            );
          case CourseParticipationStatusModel.Started:
            return this.translateService.instant(
              'ADMINISTRATION.PROCESSING-PROGRESS-STATUSES.IN-PROGRESS'
            );
          case CourseParticipationStatusModel.NoParticipation:
            return this.translateService.instant(
              'ADMINISTRATION.PROCESSING-PROGRESS-STATUSES.OPEN'
            );
          default:
            return 'n.a.';
        }
      }
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.DATE'),
      dataField: 'date',
      calculateDisplayValue: (data: ReportComplianceModel): string => {
        return data.date ? this.datePipe.transform(data.date, 'dd.MM.yyyy')! : '';
      }
    },
  ];

  constructor(
    private router: Router,
    private loadingService: LoadingService,
    private reportingService: ReportingService,
    public translateService: TranslateService,
    private datePipe: DatePipe,
  ) {
    this.yearFilter = this.yearsDropdownDataSource[0].id;
    this.loadReportingData();
  }

  loadReportingData(): void {
    this.loadingService
      .load(this.reportingService.getComplianceReport(this.yearFilter))
      .subscribe((reportData) => {
        this.reportData = reportData;
      });
  }

  navigateBack(): void {
    this.router.navigate(['/dashboard']);
  }

  onYearFilterChanged(event: any) {
    this.yearFilter = event.value ?? this.yearsDropdownDataSource[0].id;
    this.loadReportingData();
  }
}
